import { Box } from '@material-ui/core';
import { formatMoney } from '@nemuru-eng/js-api-client';

import { CardPaymentProviderLogos } from '@/components/modules/Application/components/_shared/components/ApplicationSummary/components/CardPaymentProviderLogos';
import { useCart } from '@/components/modules/Application/components/Cart/DefaultCart/components/shared/hooks/useCart';
import { PaymentHeaderWrapper } from '@/components/modules/Application/components/PaymentMethod/_shared/components/PaymentMethodCard/PaymentMethodHeader/components/PaymentHeaderWrapper';
import { SinglePaymentProviderLogo } from '@/components/modules/Application/components/PaymentMethod/_shared/components/SinglePaymentProviderLogo';
import { AbstractSinglePaymentMethod } from '@/components/modules/Application/components/PaymentMethod/_shared/entities/PaymentMethod/AbstractSinglePaymentMethod';
import { SinglePaymentMethod } from '@/components/modules/Application/components/PaymentMethod/_shared/entities/PaymentMethod/SinglePaymentMethod';
import { Font } from '@/components/shared/components/Font';
import { Icon } from '@/components/shared/components/Icon';
import { IconByAllowedPaymentMethodType } from '@/components/shared/components/PricingsTable/constants/IconByAllowedPaymentMethodType';
import { useTranslation } from '@/components/shared/hooks/useTranslation';
import { usePageContext } from '@/contexts/PageContext/PageContext';
import { useScreen } from '@/hooks/useScreen';

interface SinglePaymentHeaderComponentProps<T extends AbstractSinglePaymentMethod> {
  paymentMethodEntity: T;
}

export const SinglePaymentHeaderComponent = <T extends AbstractSinglePaymentMethod>({
  paymentMethodEntity,
}: SinglePaymentHeaderComponentProps<T>) => {
  const { xs, sm, md, lg } = useScreen();
  const { getTextIdTranslation } = useTranslation();
  const { cart } = useCart();
  const {
    state: { showLeftMenu },
  } = usePageContext();

  if (!cart) return null;

  const showProvidersLogos = (!showLeftMenu && md) || lg || (sm && !md) || (xs && !sm);

  return (
    <PaymentHeaderWrapper>
      <Icon>{IconByAllowedPaymentMethodType(paymentMethodEntity.paymentMethodType)}</Icon>
      <Box
        display="flex"
        flexDirection={'column'}
        flexGrow={1}
        alignItems={sm ? 'flex-start' : 'center'}
        flexShrink={0}
      >
        <Box display={'flex'} flexDirection={'row'} gridGap={4} alignItems={'baseline'}>
          <Font variant="body2">{getTextIdTranslation(paymentMethodEntity.paymentMethodType)}</Font>
          {paymentMethodEntity instanceof SinglePaymentMethod && <CardPaymentProviderLogos />}{' '}
        </Box>
        <Box display="flex" alignItems={'center'} maxHeight={'28px'}>
          <Font variant="body1" style={{ fontWeight: 'bold' }}>
            {paymentMethodEntity.amount
              ? formatMoney({ value: paymentMethodEntity.amount, currency: paymentMethodEntity.currency })
              : '-'}
          </Font>
        </Box>
      </Box>
      {showProvidersLogos && (
        <Box minWidth={0} overflow="hidden">
          <SinglePaymentProviderLogo providers={paymentMethodEntity.getAllProviderNames()} size={86} />
        </Box>
      )}
    </PaymentHeaderWrapper>
  );
};
